<template>
    <div class="full-width-editor-box" v-loading="loading">
        <div class="editor-title-toolbar">
            <ReturnButton
                class="return-btn"
                @click="clickReturnBtn"
                v-show="showReturnBtn !== null && showReturnBtn !== false"
                :label="returnLabel"
            />

            <div>
                <h2
                    style="margin-top: 0"
                    tkey="我的視頻"
                >
                    {{i18n.tkey("lang_my_video")}}
                </h2>
            </div>

            <div class="right-operation-btn" v-show="viewPart === 'list'">
                <el-button type="primary" @click="goAddRecord" tkey="添加">{{i18n.tkey("lang_add")}}</el-button>
            </div>
        </div>

        <div>
            <AdsList
                :list="recordList"
                v-show="viewPart === 'list'"
                @clickEdit="clickEditCallback"
                @clickDel="clickDelCallback"
            />

            <InsertOrEditAds
                :editObj="editObj"
                @save-complete="saveRecordCallback"
                v-if="viewPart === 'edit'"
            />
        </div>
    </div>
</template>

<script setup>

import AdsList from "@/components/shopopee/ads/adsList.vue";
import InsertOrEditAds from "@/components/shopopee/ads/insertOrEditAds.vue";
import {inject, ref, onBeforeMount, computed} from "vue";
import ReturnButton from "@/components/shopopee/common/returnButton.vue";
import jobArrangementRecordApi from "@/request/jobArrangementRecordApi";
import myUtil from "@/util/util";

const props = defineProps(["showReturnBtn"])
const emits = defineEmits(["clickReturnBtn"])

const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })
const i18n = inject("i18n")

const shopCompany = ref(null)
const viewPart = ref("list")
const loading = ref(false)

const recordList = ref([])
const editObj = ref(null)

const returnLabel = computed(() => {
    let text = i18n.tkey("lang_return")

    if (viewPart.value === "edit"){
        text = i18n.tkey("lang_return")
    }

    return text
})

function clickReturnBtn(){
    if (viewPart.value !== "list"){
        viewPart.value = "list"
    }else{
        emits("clickReturnBtn")
    }
}

function getAdsDataList(){
    loading.value = true

    const request = jobArrangementRecordApi.queryRecord
    const params = request.getParams()

    params.companycode = shopCompany.value.companycode
    params.jatype = '-99'

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            recordList.value = res.detail
        }else{
            myUtil.alertError(res.msg)
        }
    })
}

function clickEditCallback(obj){
    editObj.value = obj
    viewPart.value = "edit"
}

function clickDelCallback(obj){
    myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
        delRecord(obj)
    })
}

function delRecord(obj){
    loading.value = true

    const request = jobArrangementRecordApi.delRecord
    const params = request.getParams()

    params.id = obj.id

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_delete_success"))
            getAdsDataList()
        }else{
            myUtil.alertError(res.msg)
        }
    })
}

function goAddRecord(){
    editObj.value = null
    viewPart.value = "edit"
}

function saveRecordCallback(){
    editObj.value = null
    viewPart.value = "list"
    getAdsDataList()
}

onBeforeMount(() => {
    shopCompany.value = getShopCompanyObj()

    getAdsDataList()
})

</script>

<style scoped>

.header-box {
    text-align: right;
    margin-top: 12px;
    margin-bottom: 12px;
}

.editor-title-toolbar {
    text-align: center;
    position: relative;
    margin-bottom: 32px;
}

.editor-title-toolbar .return-btn {
    position: absolute;
    left: 0;
    top: 5px;
}

.editor-title-toolbar .right-operation-btn {
    position: absolute;
    right: 0;
    top: 0;
}

.full-width-editor-box {
    width: 100%;
}

</style>